
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.995 2.05v10.29l6.3 8.144A9.953 9.953 0 0112 22C6.477 22 2 17.523 2 12c0-5.184 3.944-9.446 8.995-9.95zM14.091 13h7.86a9.973 9.973 0 01-3.054 6.24L14.091 13zM13.042 2.054A10.003 10.003 0 0121.951 11h-8.91z","fill":"#2A333D"}})])
          )
        }
      }
    